import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable()
export class ComponentFactoryResolverService implements Resolve<any> {
	constructor(private componentFactoryResolver: ComponentFactoryResolver) {
	}

	/**
	 * Put available the component factory resolver on routes data for the module
	 */
	resolve(): ComponentFactoryResolver {
		return this.componentFactoryResolver;
	}
}
